// src/forms/EditionSection.jsx
import React from "react";
import { useTranslation } from "react-i18next";

const EditionSection = (props) => {
  const {
    // ancienne API
    formData: rawFormData,
    handleInputChange,
    // nouvelle API (ArtworkDetailTab / ArtworkEdit)
    value,
    onChange,
    readOnly = false,
    isLoading = false,
  } = props;

  const { t } = useTranslation();

  // on unifie tout : on travaille toujours avec `formData`
  const formData = rawFormData ?? value ?? {};

  // handler unique qui marche pour les deux API
  const internalHandleChange = (event) => {
    if (!onChange || !event?.target) return;
    const { name, type, checked, value } = event.target;
    const nextValue = type === "checkbox" ? checked : value;

    // on envoie un PATCH au parent (ArtworkEdit / ArtworkDetailTab)
    onChange({
      [name]: nextValue,
    });
  };

  const handleChange = handleInputChange || internalHandleChange;

  // Spinner explicite
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-10 text-gray-400 text-sm">
        <span className="mr-2 inline-block h-4 w-4 animate-spin rounded-full border border-gray-300 border-t-transparent" />
        {t("edition.loading")}
      </div>
    );
  }

  // ----- MODE LECTURE SEULE (fiche oeuvre) -----
  if (readOnly) {
    const hasEditionInfo = formData?.isEdition || formData?.editionInfo;

    if (!hasEditionInfo) {
      // si rien à dire → on ne rend rien, la section reste discrète
      return null;
    }

    return (
      <div className="border p-4 rounded-md space-y-2">
        <h3 className="font-medium">
          {t("edition.readOnlyEditionTitle")}
        </h3>

        <p className="text-sm">
          <span className="font-medium">
            {t("edition.readOnlyIsEdition")}
          </span>{" "}
          {formData?.isEdition
            ? t("edition.readOnlyYes")
            : t("edition.readOnlyNo")}
        </p>

        {formData?.editionInfo && (
          <p className="text-sm">
            <span className="font-medium">
              {t("edition.readOnlyDetailsTitle")}
            </span>{" "}
            {formData.editionInfo}
          </p>
        )}
      </div>
    );
  }

  // ----- MODE ÉDITION (formulaire) -----
  return (
    <section className="border p-4 rounded-md space-y-4">
      <div className="space-y-2">
        <label className="inline-flex items-center text-sm">
          <input
            type="checkbox"
            name="isEdition"
            checked={!!formData.isEdition}
            onChange={handleChange}
            className="mr-2 rounded border-gray-300"
          />
          <span>{t("edition.isEditionLabel")}</span>
        </label>

        {formData.isEdition && (
          <div className="space-y-2 mt-3">
            <label
              htmlFor="editionInfo"
              className="block text-sm font-medium text-gray-700"
            >
              {t("edition.detailsLabel")}
            </label>
            <textarea
              id="editionInfo"
              name="editionInfo"
              value={formData.editionInfo || ""}
              onChange={handleChange}
              rows={3}
              className="form-control-artsy w-full"
              placeholder={t("edition.detailsPlaceholder")}
            />
            <p className="text-xs text-gray-500">
              {t("edition.detailsHelp")}
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default EditionSection;
